import gql from 'graphql-tag';

export const GET_PERIOD_DOCUMENTS_SUMMARY = gql`
  query GetPeriodDocumentsSummary($periodsFolderId: String!, $onlyInvoices: Boolean) {
    accounting {
      getPeriodDocumentsSummary(
        periodsFolderId: $periodsFolderId
        onlyInvoices: $onlyInvoices
      ) {
        fileId
        date
        source
        document
        type
        counterparty
        vat
        isVatValid
        direction
        amount
        status
        article
        tax
        error
        mustResubmitDeclaration
        statementTransactionsCount
        importedTransactionsCount
      }
    }
  }
`;

export const GET_PERIOD_TRANSACTIONS_SUMMARY = gql`
  query GetPeriodTransactionsSummary($periodsFolderId: String!) {
    accounting {
      getPeriodTransactionsSummary(periodsFolderId: $periodsFolderId) {
        transactionId
        parentTransactionId
        date
        amount
        counterparty
        invoices {
          fileId
          name
        }
        category
        article
        tax
        docNeeded
        isInternalTransfer
        internalTransferTransactionId
        internalTransferPair {
          transactionId
          date
          amount
          bankAccount
        }
        bankAccount
        statementFileId
        status
        comment
        error
      }
    }
  }
`;
